import styled from "styled-components";

export interface RootProps {
  breakpoint?: string;
}

export const Root = styled.div<RootProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 24px;

  @media (min-width: ${props => props.breakpoint || "768px"}) {
    flex-direction: row;
    align-items: center;
  }
`;
